"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EpubReaderProvider = exports.EpubReaderContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../utils");
var _book = require("../constants/book");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */

var EpubReaderContext = exports.EpubReaderContext = /*#__PURE__*/(0, _react.createContext)();
var EpubReaderProvider = _ref => {
  var {
    userId,
    uuid,
    bookTitle,
    applicationToken,
    sessionToken,
    backToBds,
    children
  } = _ref;
  var [epubFile, setEpubFile] = (0, _react.useState)(null);
  var [rendition, setRendition] = (0, _react.useState)(null);
  var [cfi, setCfi] = (0, _react.useState)(0);
  var [chapters, setChapters] = (0, _react.useState)([]);
  var [selectedChapter, setSelectedChapter] = (0, _react.useState)('');
  var [currentLocation, setCurrentLocation] = (0, _react.useState)(null);
  var [currentEndLocation, setCurrentEndLocation] = (0, _react.useState)(null);
  var [totalLocation, setTotalLocation] = (0, _react.useState)(null);
  var [currentPercentage, setCurrentPercentage] = (0, _react.useState)(null);
  var [showingOfflineMessage, setOfflineMessage] = (0, _react.useState)(false);
  var [isAppOffline, setAppOffline] = (0, _react.useState)(false);
  var [loadingLocations, setLoadingLocations] = (0, _react.useState)(true);
  var [bookFile, setBookFile] = (0, _react.useState)();
  var [showingOnlineMessage, setOnlineMessage] = (0, _react.useState)(false);
  function jumpToPage(_cfi) {
    var rend = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : rendition;
    setCfi(_cfi);
    return rend.display(_cfi);
  }
  function getChapterName(pageReference) {
    var _chapter$label;
    var {
      book
    } = rendition;
    var spineItem = book.spine.get(pageReference);
    var items = (0, _utils.flattenArray)(book.navigation.toc, 'subitems');
    var chapter = items.find(el => el.href.includes(spineItem.href));
    return chapter === null || chapter === void 0 || (_chapter$label = chapter.label) === null || _chapter$label === void 0 ? void 0 : _chapter$label.trim();
  }
  function getBookTotalChars() {
    return _book.CHARS_PER_PAGE * rendition.book.locations.length();
  }
  return /*#__PURE__*/_react.default.createElement(EpubReaderContext.Provider, {
    value: {
      userId,
      applicationToken,
      sessionToken,
      uuid,
      backToBds,
      setEpubFile,
      epubFile,
      rendition,
      setRendition,
      cfi,
      setCfi,
      chapters,
      setChapters,
      getChapterName,
      selectedChapter,
      setSelectedChapter,
      jumpToPage,
      bookTitle,
      setCurrentLocation,
      currentLocation,
      setCurrentEndLocation,
      currentEndLocation,
      setTotalLocation,
      totalLocation,
      setCurrentPercentage,
      currentPercentage,
      showingOfflineMessage,
      setOfflineMessage,
      setAppOffline,
      isAppOffline,
      loadingLocations,
      setLoadingLocations,
      bookFile,
      setBookFile,
      getBookTotalChars,
      setOnlineMessage,
      showingOnlineMessage
    }
  }, children);
};
exports.EpubReaderProvider = EpubReaderProvider;
EpubReaderProvider.propTypes = {
  children: _propTypes.default.node.isRequired,
  userId: _propTypes.default.number.isRequired,
  uuid: _propTypes.default.string.isRequired,
  bookTitle: _propTypes.default.string.isRequired,
  applicationToken: _propTypes.default.string.isRequired,
  sessionToken: _propTypes.default.string.isRequired,
  backToBds: _propTypes.default.func
};
EpubReaderProvider.defaultProps = {
  backToBds: () => {}
};